import { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { IoIosNotificationsOutline } from "react-icons/io";
import { IoNotificationsOutline } from "react-icons/io5";
import CustomButton from "./CustomButton";
import "../assets/css/CustomHeader.css";
import logoImage from '../assets/icons/tennismate-logo.png'
import { saveFilterUpdating, saveProfileData, saveSelectedLocations, saveToken, saveUserData } from "../redux/UserDataSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { FaRegCircleUser } from "react-icons/fa6";
import { Button, UncontrolledPopover, PopoverBody } from 'reactstrap';
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { IoLocationOutline } from "react-icons/io5";
import CustomModal from "./CustomModal";
import axios from 'axios';
import { endpoint } from '../assets/api/endpoint';
import { apiHandler } from '../assets/api';
import { toast } from 'react-toastify';
import { useLocation } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import { saveCurrentLocation, saveProfileFilterUpdate } from "../redux/UserDataSlice";
import LogoutModal from "./LogOutModal";
import { BsChatDots } from "react-icons/bs";
import NavbarModal from "./NavBarModal";




const CustomHeader = () => {
  const navigate = useNavigate();
  const loggedInData = useSelector((state, selectedLocations) => state?.loginInfo.loggedIn)
  const loggedIn = loggedInData;
  const { accessToken } = useSelector((state) => state?.loginInfo.accessToken);

  const [isLoggedIn, setIsLoggedIn] = useState(loggedIn);
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const { profileData, filterUpdating, filterGameUpdating, userId } = useSelector((state) => state?.loginInfo);
  const { unseenData, profilefilterUpdate } = useSelector((state) => state?.loginInfo);

  const [currentLocation, setCurrentLocation] = useState();
  const [profileLocation, setProfileLocation] = useState();
  const [otherLocation, setOtherLocation] = useState();
  const [locationResults, setLocationResults] = useState([]);
  const [selectedCoordinatesOther, setSelectedCoordinates] = useState({ latitude: null, longitude: null });
  const [location, setLocation] = useState({ latitude: '', longitude: '' });
  const locations = useLocation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedLocations, setSelectedLocations] = useState({
    profileLocation: true,
    currentLocation: false,
    others: false,
  });
  const [isNavModalOpen, setIsNavModalOpen] = useState(false);
  const [recentSearches, setRecentSearches] = useState([]);
  const [otherLocatonModal, setOtherLocatonModal] = useState(false);
  const [loading, setLoading] = useState();
  const [isFixed, setIsFixed] = useState(false);
  const [gameFilterData, setGameFilterData] = useState(null);


  const getLocationName = async (lat, lng) => {
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;
   if(accessToken){
    try {
      const response = await fetch(url);
      const data = await response.json();

      if (data.status === 'OK') {
        const address = data.results[0]?.formatted_address;
        return address;
      } else {
        console.error('Geocoding error:', data.status);
        return null;
      }
    } catch (error) {
      console.error('Error fetching location:', error);
      return null;
    }
  }
  };

  const handleLocationChange = (key) => {
    setSelectedLocations({
      profileLocation: key === "profileLocation",
      currentLocation: key === "currentLocation",
      others: key === "others",
    });
    if (key == 'others') {
      setOtherLocatonModal(true);
    } else {
      setOtherLocation('');
    }
  };
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          getLocationName(latitude, longitude)
            .then((address) => {
              setCurrentLocation(address)
              dispatch(saveCurrentLocation({ address }))
            });
        },
        (error) => {
          console.error('Error fetching location:', error);
        }
      );
    }
  }, [accessToken])

  useEffect(() => {
    setIsLoggedIn(loggedIn);
  }, [loggedIn, accessToken]);

  useEffect(() => {
    getLocationName(profileData?.baseProfile?.latitude, profileData?.baseProfile?.longitude)
      .then((address) => {
        setProfileLocation(address)
      });
    setSelectedCoordinates({})
    dispatch(saveSelectedLocations(selectedLocations))
  }, [selectedLocations, accessToken])

  useEffect(() => {
    const stored = localStorage.getItem('recentLocations');
    if (stored) {
      setRecentSearches(JSON.parse(stored));
    }
  }, [accessToken]);

  useEffect(() => {
    const fetchLocation = async () => {
      if (otherLocation?.length >= 3) {
        try {
          const response = await axios.get('https://maps.googleapis.com/maps/api/geocode/json', {
            params: {
              address: otherLocation,
              key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
            }
          });

          if (response?.data?.results && response.data.results.length > 0) {
            const locations = response.data.results.map(result => ({
              name: result?.formatted_address,
              lat: result?.geometry?.location.lat,
              lng: result?.geometry?.location.lng
            }));
            setLocationResults(locations);
          } else {
            setLocationResults([]);
          }
        } catch (error) {
          console.error('Error fetching location:', error);
        }
      } else {
        setLocationResults([]);
      }
    };

    const delayDebounceFn = setTimeout(fetchLocation, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [otherLocation, accessToken]);

  useEffect(() => {
    if (selectedLocations.others) {
      setSelectedCoordinates(location);
      getLocationName(location.latitude, location?.longitude)
        .then((address) => {
          setOtherLocation(address);
        });
    }
  }, [selectedLocations.others, accessToken]);



  const handleSelectLocation = (loc) => {
    const selected = { name: loc.name, lat: loc.lat, lng: loc.lng };

    setRecentSearches(prev => {
      const updated = [selected, ...prev.filter(item => item.name !== selected.name)].slice(0, 5);
      localStorage.setItem('recentLocations', JSON.stringify(updated)); // persist to localStorage
      return updated;
    });

    setSelectedCoordinates({ latitude: loc.lat, longitude: loc.lng });
    setOtherLocation(loc.name);
    setLocationResults([]);
    setLocation({ latitude: loc.lat, longitude: loc.lng });
  };

  const handleLogin = () => navigate("/login");
  const handleLogout = () => {
    setShowModal(true);
  };
  const handleNotification = () => navigate("/notification");

  const handleConfirmLogout = async () => {

    try {
      const result = await apiHandler({
        url: endpoint.LOG_OUT,
        method: "GET",
        authToken: accessToken
      });
      console.log('resultHandleConfirmLogout', result.data)
      if (result.data.success === true) {
        navigate("/");
        toast.success(result.data.message || 'Logout successfully completed')
      } else {
        toast.error(result.data.message || "Something went wrong please try again")
      }

    } catch (error) {
      console.error("Error fetching filter data", error);
    }
    setIsLoggedIn(false);
    navigate("/");
    setShowModal(false);
    dispatch(saveToken(''))
  };

  const handleCancelLogout = () => {
    setShowModal(false);
  };

  const closeLocationModal = (data) => {
    setIsDropdownOpen(false)
  }

  useEffect(() => {
    const fetchLocation = async () => {
      if (otherLocation?.length >= 3) {
        try {
          const response = await axios.get('https://maps.googleapis.com/maps/api/geocode/json', {
            params: {
              address: otherLocation,
              key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
            }
          });

          if (response?.data?.results && response?.data?.results.length > 0) {
            const locations = response.data.results.map(result => ({
              name: result?.formatted_address,
              lat: result?.geometry?.location.lat,
              lng: result?.geometry?.location.lng
            }));
            setLocationResults(locations);
          } else {
            setLocationResults([]);
          }
        } catch (error) {
          console.error('Error fetching location:', error);
        }
      } else {
        setLocationResults([]);
      }
    };

    const delayDebounceFn = setTimeout(fetchLocation, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [otherLocation, accessToken]);

  useEffect(() => {
    if (selectedLocations.profileLocation) {
      setLocation({
        latitude: profileData?.baseProfile?.latitude,
        longitude: profileData?.baseProfile?.longitude
      });
    }
    else if (selectedLocations.currentLocation) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            getLocationName(latitude, longitude)
              .then((address) => {
                setCurrentLocation(address);
              });
            setLocation({ latitude, longitude });
          },
          (error) => {
            console.error('Error fetching location:', error);
          }
        );
      }
    }
    else if (selectedLocations.others) {
      // console.log('Other Location Selected - user needs to enter a location');
    }
    else {
      // console.log('No location selected');
    }
  }, [selectedLocations, accessToken]);

  useEffect(() => {
    const fetchProfileFilterData = async () => {
      setLoading(true);
      try {
        const result = await apiHandler({
          url: endpoint.FETCH_PROFILE_FILTER_DATA,
          method: "GET",
          authToken: accessToken
        });

        if (result.data) {
          const apiLat = result.data.latitude;
          const apiLng = result.data.longitude;

          const storedCoordinates = JSON.parse(localStorage.getItem("coordinates"));

          setLocation({ latitude: apiLat, longitude: apiLng });
          if (
            apiLat === profileData?.baseProfile?.latitude &&
            apiLng === profileData?.baseProfile?.longitude
          ) {
            setSelectedLocations({
              profileLocation: true,
              currentLocation: false,
              others: false
            });
          } else if (
            apiLat === storedCoordinates?.latitude &&
            apiLng === storedCoordinates?.longitude
          ) {
            setSelectedLocations({
              profileLocation: false,
              currentLocation: true,
              others: false
            });
          } else {
            setSelectedLocations({
              profileLocation: false,
              currentLocation: false,
              others: true
            });


          }
        }
      } catch (error) {
        console.error("Error fetching filter data", error);
      }

      setTimeout(() => setLoading(false), 3000);
    };

    const fetchGameFilterData = async () => {
      try {
        const result = await apiHandler({
          url: endpoint.FETCH_GAME_FILTER_DATA,
          method: "GET",
          authToken: accessToken
        });

        if (result.data) {
          const apiLat = result.data.latitude;
          const apiLng = result.data.longitude;
          setGameFilterData(result.data);
          const storedCoordinates = JSON.parse(localStorage.getItem("coordinates"));
          setLocation({ latitude: apiLat, longitude: apiLng });
          if (apiLat === profileData?.baseProfile?.latitude && apiLng === profileData?.baseProfile?.longitude) {
            setSelectedLocations({
              profileLocation: true,
              currentLocation: false,
              others: false
            });
          } else if (apiLat === storedCoordinates?.latitude && apiLng === storedCoordinates?.longitude) {
            setSelectedLocations({
              profileLocation: false,
              currentLocation: true,
              others: false
            });
          } else {
            setSelectedLocations({
              profileLocation: false,
              currentLocation: false,
              others: true
            });
          }
        }
      } catch (error) {
        console.error("Error fetching filter data", error);
      }
    };
    if (accessToken) {
      if (locations?.pathname === '/stringer' || locations?.pathname === '/invite-player' || locations?.pathname === '/findplayer') {
        fetchProfileFilterData();
      } else {
        fetchGameFilterData()
      }
    }

  }, [filterUpdating, filterGameUpdating, accessToken]);


  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 60) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    getLocationName(location?.latitude, location?.longitude)
      .then((address) => {
        setProfileLocation(address)
      });
  }, [accessToken])

  const onFilter = async () => {
    setLoading(true);
    const filters = {
      longitude: location.longitude,
      latitude: location.latitude,
      maxDistance: gameFilterData.maxDistance,
    };

    try {
      let result = {};
      if (locations?.pathname === '/stringer' || locations?.pathname === '/findplayer' || locations?.pathname === '/invite-player') {
        result = await apiHandler({
          url: endpoint.USER_SEARCH_FILTER,
          method: "POST",
          authToken: accessToken,
          data: filters
        });
        if (result.data) {
          dispatch(saveFilterUpdating(!filterUpdating))
        }
      } else {
        result = await apiHandler({
          url: endpoint.FILTER_GAME_DATA,
          method: "POST",
          authToken: accessToken,
          data: filters
        });
      }

      const response = result?.data?.message;
      if ((response === "Filter created" || response === "Filter updated") && result?.data?.code !== 500) {
        dispatch(saveProfileFilterUpdate(!profilefilterUpdate));
        toast.success(response);
        setIsDropdownOpen(false);
      } else {
        toast.error("Failed to apply filters. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred while applying filters.");
    } finally {
      setLoading(false);
    }
  };

  const openNavModal = () => setIsNavModalOpen(true);
  const closeNavModal = () => setIsNavModalOpen(false);

  const onClickFilter = async () => {
    setLoading(true);
    try {
      const result = await apiHandler({
        url: endpoint.REMOVE_FILTER_GAME,
        method: "POST",
        authToken: accessToken,
      });
      const response = result?.data?.message;
      if ((response == "Filter created" || "No filters found to be cleared") && (result?.data?.code != 500)) {
        dispatch(saveProfileFilterUpdate(!profilefilterUpdate));
        toast.success(response);
        setSelectedLocations({ profileLocation: "profileLocation", others: false, });

        // onClearFilter(!clearFilter);
      } else {
        toast.error("Failed to apply filters. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred while applying filters.");
    }
    setTimeout(() => setLoading(false), 5000);
  }

  const onProfile = () => {
    navigate('/profile')
  }

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-white px-4" style={{ display: ` ${isFixed && locations?.pathname == '/your-games' ? 'none' : 'flex'} ` }}>
        <div className="navbar-brand font-weight-bold">
          <img src={logoImage} />
          {/* <NavbarModal/> */}
        </div>

        {accessToken ?
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" onClick={() => openNavModal()}></span>
          </button>
          :

          <CustomButton buttonText="Log In" className="create-account mobile-log-in" style={{ padding: '10px 0px', minWidth: '134px' }} onClick={handleLogin} />
        }
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav mx-auto">
            {accessToken && (
              <>
                <li className="nav-item">
                  <NavLink to="/explore" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                    Explore
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to="/your-games" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                    Your Games
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to="/findplayer" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                    Find Players
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to="/stringer" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                    Stringer
                  </NavLink>
                </li>

              </>
            )}
          </ul>
          <div className="d-flex align-items-center">
            <div className="me-3">
              {!accessToken ? (
                <>
                  <CustomButton
                    buttonText="Log In"
                    className="create-account "
                    style={{ padding: '10px 0px', minWidth: '134px' }}
                    onClick={handleLogin}
                  />
                </>
              ) : ''
              }
            </div>
            {accessToken && (
              <div className="d-flex align-items-center ">
                <div className={`d-flex align-items-center me-4 ${` ${locations?.pathname === '/explore' || locations?.pathname === '/invite-player' || locations?.pathname === '/findplayer' || locations?.pathname === '/stringer' ? 'd-block ' : 'invisible'}`}`} style={{ cursor: 'pointer' }} onClick={toggleDropdown}>
                  <div className="me-1">
                    <IoLocationOutline style={{ fontSize: '29px' }} />
                  </div>
                  <div>
                    <h4 className="cursor-pointer d-flex justify-content-between align-items-center" >
                      <span style={{ fontSize: '15px', fontWeight: '600', marginRight: '15px' }}> {selectedLocations?.currentLocation == true ? ' CURRENT LOCATION' : selectedLocations?.profileLocation == true ? 'PROFILE LOCATION' : 'OTHER LOCATION'}</span>
                      <span >
                        {isDropdownOpen ? <FaChevronUp style={{ fontSize: '14px' }} /> : <FaChevronDown style={{ fontSize: '14px' }} />}
                      </span>
                    </h4>
                    <Tooltip id="location-tooltip" place="top" effect="solid" />
                    <span
                      data-tooltip-id="location-tooltip"
                      data-tooltip-content={
                        (selectedLocations?.profileLocation
                          ? profileData?.baseProfile?.city
                          : selectedLocations?.currentLocation
                            ? currentLocation
                            : otherLocation) || ''
                      }
                      style={{ fontSize: '15px', display: 'block', marginTop: '-15px' }}
                    >
                      {((selectedLocations?.profileLocation
                        ? profileData?.baseProfile?.city
                        : selectedLocations?.currentLocation
                          ? currentLocation
                          : otherLocation) || ''
                      ).length > 20
                        ? `${(selectedLocations?.profileLocation
                          ? profileData?.baseProfile?.city
                          : selectedLocations?.currentLocation
                            ? currentLocation
                            : otherLocation).slice(0, 20)}...`
                        : (selectedLocations?.profileLocation
                          ? profileData?.baseProfile?.city
                          : selectedLocations?.currentLocation
                            ? currentLocation
                            : otherLocation)}
                    </span>
                  </div>
                </div>
                <div className="nav-item">
                  <NavLink to="/chat" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                    <BsChatDots size={35} />
                  </NavLink>
                </div>
                <div className="notification-container">
                  <IoNotificationsOutline
                    size={35}
                    style={{ cursor: "pointer", fontSize: '35px' }}
                    onClick={handleNotification}
                  />
                  {unseenData > 0 && <div className="unseeNotification"> {unseenData}</div>}
                </div>
                <Button id="PopoverFocus" type="button" className="profile-icon" >
                  {profileData?.baseProfile?.avatarUrl ? <img src={profileData?.baseProfile?.avatarUrl} width='35px' height='35px' style={{ borderRadius: '30px' }} /> : <FaRegCircleUser style={{ fontSize: '35px' }} />}
                </Button>

                <UncontrolledPopover
                  placement="bottom"
                  target="PopoverFocus"
                  trigger="click"
                >
                  <PopoverBody
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/profile")}
                  >
                    <Link to="/profile" className="nav-link">
                      <div className="" onClick={onProfile}>
                        Profile
                      </div>
                    </Link>
                  </PopoverBody>
                  {profileData?.subscriptionStatus && (
                    <PopoverBody style={{ cursor: "pointer" }}>
                      Subscription: <strong>{profileData?.subscriptionStatus}</strong>
                    </PopoverBody>
                  )}
                  <div style={{ marginTop: '-25px' }}>
                    <PopoverBody
                      style={{ cursor: "pointer" }}
                      onClick={() =>handleLogout()}
                    >
                      <Link className="nav-link">
                        Log-Out
                      </Link>
                    </PopoverBody>
                  </div>
                </UncontrolledPopover>

              </div>
            )}
          </div>
        </div>

        {isDropdownOpen && (
          <CustomModal closeModal={closeLocationModal} modalIsOpen={isDropdownOpen} >
            <div className="d-flex align-items-center justify-content-center w-100 h-100">
              <div className="w-100 h-65">
                <div className="d-flex justify-content-between mb-2">
                  <span className="text-primary cursor-pointer" style={{ cursor: 'pointer', fontWeight: '700' }} onClick={() => closeLocationModal()}>Cancel</span>
                  <span className={`text-danger fs-6 ${loading ? 'disabled-span' : 'cursor-pointer'}`} style={{ cursor: loading ? 'not-allowed' : 'pointer', fontWeight: '700', opacity: loading ? 0.5 : 1 }}
                    onClick={!loading ? onClickFilter : undefined}
                  >
                    Clear All
                  </span>
                </div>

                <div className="form-check mb-2 profile-location-card">
                  <input className="form-check-input"
                    type="checkbox"
                    id="profileLocation"
                    checked={selectedLocations?.profileLocation}
                    onChange={() => handleLocationChange("profileLocation")}
                  />

                  <label className="form-check-label d-flex justify-content-between" htmlFor="profileLocation">
                    <span>Profile Location</span> <span> {profileData?.baseProfile?.city}</span>
                  </label>
                </div>
                <div className="form-check mb-2 profile-location-card">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="currentLocation"
                    checked={selectedLocations?.currentLocation}
                    onChange={() => handleLocationChange("currentLocation")}
                  />
                  <label className="form-check-label d-flex justify-content-between" htmlFor="currentLocation">
                    <span> Current Location </span><span>{currentLocation}</span>
                  </label>
                </div>
                <div className="form-check mb-4 profile-location-card">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="others"
                    checked={selectedLocations.others}
                    onChange={() => handleLocationChange("others")}
                  />
                  <label className="form-check-label d-flex justify-content-between" htmlFor="others">
                    <span> Others</span> <span> {otherLocation}</span>
                  </label>
                </div>

                {selectedLocations.others && otherLocatonModal && (
                  <div className="modal bottom-modal show d-block" tabIndex="-1" role="dialog">
                    <div className="modal-dialog modal-dialog-scrollable" role="document">
                      <div className="modal-content modal-content-scrollable">
                        <div className="modal-header">
                          <h5 className="modal-title">Search Location</h5>
                          <button
                            type="button"
                            className="btn-close"
                            onClick={() => {
                              setOtherLocatonModal(false)
                            }}
                            aria-label="Close"
                          ></button>
                        </div>
                        <div className="modal-body">
                          <div className="location-search-container">
                            <input
                              type="text"
                              placeholder="Enter location"
                              value={otherLocation}
                              onChange={(e) => setOtherLocation(e.target.value)}
                              className="border p-2 w-full"
                              style={{ width: '75%', borderRadius: '10px' }}
                            />

                            {!selectedCoordinatesOther?.latitude ? (
                              otherLocation && locationResults?.length > 0 && (
                                <div className="other-location-pop-up p-3 bg-white border mt-2 rounded shadow">
                                  {locationResults.map((loc, index) => (
                                    <div
                                      key={index}
                                      onClick={() => handleSelectLocation(loc)}
                                      className="location-item cursor-pointer p-2 hover:bg-gray-100"
                                    >
                                      {loc.name}
                                    </div>
                                  ))}
                                </div>
                              )) : ""
                            }
                            {
                              otherLocation?.length < 3 && recentSearches?.length > 0 && (
                                <div className="other-location-pop-up p-3 bg-white border mt-2 rounded shadow">
                                  <div className="text-sm font-semibold mb-2">Recent Searches:</div>
                                  {recentSearches.map((loc, index) => (
                                    <div
                                      key={index}
                                      onClick={() => handleSelectLocation(loc)}
                                      className="location-item cursor-pointer p-2 hover:bg-gray-100"
                                    >
                                      {loc.name}
                                    </div>
                                  ))}
                                </div>
                              )
                            }

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <CustomButton buttonText={"Select Address"} className="border" style={{ width: "100%", height: "45px", borderRadius: "12px", background: "#006FFD", color: "#FFFFFF", marginRight: "35px", }}
                  onClick={onFilter}
                  disabled={loading}
                />
              </div>
            </div>

          </CustomModal>)
        }
      </nav>

      <LogoutModal
        show={showModal}
        onConfirm={handleConfirmLogout}
        onCancel={handleCancelLogout}
        text={'Are you sure you want to log out?'}
      />

      {isNavModalOpen && (
        <div className={`mobile-header-modal ${isNavModalOpen ? 'slide-in-right' : 'slide-out-right'
          }`}  >
          <NavbarModal isOpen={isNavModalOpen} closeModal={() => closeNavModal()}>
            <div>
              <ul className="list-unstyled text-center">
                <li><NavLink to="/explore" className="nav-link" onClick={closeNavModal}>Explore Game</NavLink></li>
                <li><NavLink to="/your-games" className="nav-link" onClick={closeNavModal}>Your Games</NavLink></li>
                <li><NavLink to="/chat" className="nav-link" onClick={closeNavModal}>Messenger</NavLink></li>
                <li><NavLink to="/stringer" className="nav-link" onClick={closeNavModal}>Stringer</NavLink></li>
                <li><NavLink to="/notification" className="nav-link" onClick={closeNavModal}>Notification</NavLink></li>
                <li><NavLink to="/findplayer" className="nav-link" onClick={closeNavModal}>Find Players</NavLink></li>
                <li className="nav-item">
                  <Link to="/profile" className="nav-link">
                    Profile
                  </Link>
                </li>
              </ul>
            </div>
          </NavbarModal>
        </div>
      )}

    </>

  );
};

export default CustomHeader;
